<template>
    <v-dialog v-model="getModalImprimirOrcamento" max-width="720" persistent>
        <v-card>
            <v-card-title>Imprimir</v-card-title>
            <v-card-text>
                <v-flex xs12 md12>
                    <v-btn color="primary" outlined block class="mt-2" @click="imprimirOrcamento4a(getOrcamento.id)"
                        :loading="$store.getters.getOverlay">Impressão A4</v-btn>
                </v-flex>
                <v-flex xs12 md12>
                    <v-btn color="primary" outlined block class="mt-2 mb-2"
                        @click="imprimirOrcamentoCupom(getOrcamento.id)" :loading="$store.getters.getOverlay">Impressão
                        Cupom</v-btn>
                </v-flex>
                <!-- <v-flex xs12 md12>
                    <v-btn color="primary" outlined block class="mt-2 mb-2" @click="setModalInfoProposta(true)"
                        :loading="$store.getters.getOverlay">Impressão Proposta</v-btn>
                </v-flex> -->
            </v-card-text>
            <v-card-actions>
                <v-btn color="default" @click="setModalImprimirOrcamento(false)"
                    outlined block>Voltar</v-btn>
                <v-spacer></v-spacer>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'
    export default {
        computed: {
            ...mapGetters([
                'getModalImprimirOrcamento',
                'getOrcamento'
            ])
        },
        methods: {
            ...mapActions([
                'setModalImprimirOrcamento',
                'imprimirOrcamento4a',
                'imprimirOrcamentoCupom',
                'imprimirPropostaA4',
                'setModalInfoProposta'
            ])
        }
    }
</script>